module.exports = __webpack_public_path__ + "labioplastika_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_3_after.jpg
// module id = 1071
// module chunks = 0